<div class="relative h-full w-full" [ngClass]="classes()">
  <ion-spinner
    name="crescent"
    class="absolute left-1/2 top-1/2 h-6 w-6 -translate-x-1/2 -translate-y-1/2 text-neutral-600 dark:text-neutral-500"
    [style.display]="isImageLoaded() ? 'none' : 'block'"
  ></ion-spinner>

  <ion-img
    class="h-full w-full"
    [src]="src()"
    alt="{{ alt() }}"
    (ionImgDidLoad)="onImageLoad()"
    [style.opacity]="isImageLoaded() ? 1 : 0"
  ></ion-img>
</div>
